import { render } from "./BarChart.vue?vue&type=template&id=6534eb4a&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=6534eb4a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\taka3\\vchartren2\\vue-chart2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6534eb4a"]])

export default __exports__